export default __webpack_public_path__ + "static/media/semanticui.ba0a0eef.png";